var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "top-nav" },
        [
          _vm.station
            ? _c("teams-overview", {
                class: _vm.classObj,
                attrs: { classObj: _vm.classObj, teams: _vm.teams }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.station
            ? _c("screen-indicator", {
                attrs: {
                  token: _vm.presentationScreenToken,
                  haveScreen: _vm.haveScreen && _vm.connected
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.loading
        ? _c("div", [_c("p", [_vm._v("Loading...")])])
        : _c("router-view", {
            attrs: { classUuid: _vm.classUuid },
            on: { stationsOverview: _vm.clearStation }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }